// 会员趋势数据模块
const state = {
  // 会员活跃趋势数据
  memberTrend: {
    dates: [],
    values: []
  }
}

const mutations = {
  // 设置会员趋势数据
  SET_MEMBER_TREND(state, data) {
    state.memberTrend = data
  },
  // 重置会员趋势数据
  RESET_MEMBER(state) {
    state.memberTrend = {
      dates: [],
      values: []
    }
  }
}

const actions = {
  // 获取会员趋势数据
  async fetchMemberTrend({ commit }) {
    try {
      const response = await this._vm.$api.getMemberTrend()
      commit('SET_MEMBER_TREND', response.data)
    } catch (error) {
      console.error('获取会员趋势数据失败:', error)
    }
  }
}

const getters = {
  memberTrend: state => state.memberTrend
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
